import moment from 'moment'
import XHRPromise from 'xhr-promise'
import Helpers from '../modules/Helpers'
import Reveal from '../modules/Reveal'
import ButtonCounter from '../modules/ButtonCounter'
import CalendarRange from '../modules/CalendarRange'
import Map, { streetLayer } from '../modules/Map'
import GeoSearch from '../modules/GeoSearch'

const superSearch = document.getElementById('superSearch')
const superSearchImage = document.getElementById('superSearchImage')
const superSearchGroup = document.getElementById('superSearchGroup')
const superSearchToggles = document.getElementsByClassName('super-search__button')
const superSearchDropdowns = document.getElementsByClassName('super-search__dropdown')
const superSearchClose = document.getElementsByClassName('super-search__close')

// Super search active classes
const superSearchActiveClass = 'super-search--active'
const dropdownActiveClass = 'super-search__dropdown--active'
const toggleActiveClass = 'super-search__button--active'

// Toggle super search dropdown open and closed
// when corresponding toggle button is clicked.
new Helpers(superSearchToggles).eventListener((e) => {
    e.preventDefault()

    const body = document.querySelector('body')
    const currentToggle = document.getElementById(e.currentTarget.id)
    const currentDropdownId = e.currentTarget.getAttribute('aria-controls')
    const currentDropdown = document.getElementById(currentDropdownId)
    const isShown = new Helpers(currentDropdown).hasClass(dropdownActiveClass)
    const targetIsSearchResult = new Helpers(e.target).getClosest('.geo-search-result')
    const isWhereSearchBox = currentToggle.id === 'whereToGoToggle' && (e.target.tagName.toLowerCase() === 'input' || targetIsSearchResult)

    if (!isShown) {
        // Hide all currently active dropdowns in order
        // to ensure only one is open at a time.
        new Helpers(superSearchDropdowns).removeClass(dropdownActiveClass)
        new Helpers(superSearchToggles).removeClass(toggleActiveClass)

        // Add active classes to super search elements
        // in order to display correct dropdown.
        new Helpers(superSearch).addClass(superSearchActiveClass)
        new Reveal(currentDropdown).show(dropdownActiveClass)
        new Helpers(currentToggle).addClass(toggleActiveClass)

        if (currentToggle.id === 'whereToGoToggle') {
            if (map === null) {
                getGeography()
            } else {
                map.map.invalidateSize()
                map.fitShapes()
            }
        }
        if (window.outerWidth <= 600) {
            new Helpers(body).addClass('no-scroll')
        }

        superSearch.setAttribute('data-active-dropdown', currentToggle.id)
    } else if (!isWhereSearchBox) {
        // Hide all currently active dropdowns
        new Helpers(superSearchDropdowns).removeClass(dropdownActiveClass)
        new Helpers(superSearchToggles).removeClass(toggleActiveClass)

        new Helpers(superSearch).removeClass(superSearchActiveClass)
        new Helpers(body).removeClass('no-scroll')
        superSearch.removeAttribute('data-active-dropdown')
    }
})


new Helpers(superSearchClose).eventListener((e) => {
    e.preventDefault()

    new Helpers(superSearch).removeClass(superSearchActiveClass)
    new Reveal(superSearchDropdowns).hide(dropdownActiveClass)
    new Helpers(superSearchToggles).removeClass(toggleActiveClass)
    new Helpers(document.querySelector('body')).removeClass('no-scroll')
})

// Remove all super search active classes when
// clicking off super search dropdowns to ensure
// all dropdowns can be closed when no longer wanted.
new Helpers(superSearchImage).eventListener((e) => {
    e.preventDefault()

    new Helpers(superSearch).removeClass(superSearchActiveClass)
    new Reveal(superSearchDropdowns).hide(dropdownActiveClass)
    new Helpers(superSearchToggles).removeClass(toggleActiveClass)
})


// Stop super search group children events
// bubbling after their own handler executes.
new Helpers(superSearchGroup).eventListener((e) => {
    e.stopPropagation()
})

if (superSearch !== null) {
    (() => {
        const rootLocationRegionCode = superSearch.querySelector('.super-search__areas').getAttribute("data-root-location")
        let activeFetch = -1
        let activeGeoFetch = -1
        let locationModified = false
        const regions = superSearch.getElementsByClassName('location-region')
        const allTowns = superSearch.getElementsByClassName('super-search__towns')[0]
        const distance = document.getElementsByName('distance')[0]

        new Helpers(superSearch.getElementsByTagName('form')).eventListener((e) => {
            e.preventDefault()

            if (destinationUrl() !== '') {
                window.location.href = destinationUrl()
            }
        }, 'submit')

        let destinationUrl = (mapView = false) => {
            const params = getParams()
            const setParams = Object.keys(params).length

            let destination = ''
            if (mapView) {
                return `/results.aspx?search=Y&view=map&${queryString(params)}`
            }
            if (setParams === 1 && params.rgn !== undefined) {
                // use region url
                destination = Array.from(regions).filter(r => r.getAttribute('data-value') === params.rgn)[0].getElementsByTagName('a')[0].href
            } else if (setParams === 2 && params.nlc !== undefined) {
                destination = `/holiday-cottages-${params.nlc.toLowerCase()}.html`
            } else if (setParams === 0) {
                destination = Array.from(regions).filter(r => r.getAttribute('data-value') === rootLocationRegionCode)[0].getElementsByTagName('a')[0].href
            } else {
                destination = `/results.aspx?search=Y&${queryString(params)}`
            }
            return destination

        }

        new Helpers(regions).eventListener((e) => {
            e.preventDefault()
            e.stopPropagation()
            let featuredIds = []
            if (e.target.getAttribute('data-toptowns') !== null) {
                featuredIds = e.target.getAttribute('data-toptowns').split(",")
            } else if (e.target.parentElement.getAttribute('data-toptowns') !== null) {
                featuredIds = e.target.parentElement.getAttribute('data-toptowns').split(",")
            }

            new Helpers(regions).setAttributes({ 'aria-current': false })
            new Helpers(e.currentTarget).setAttributes({ 'aria-current': true })

            // clear selected town
            const allTownsList = allTowns.querySelectorAll('.super-search__towns .location-town')
            new Helpers(allTownsList).setAttributes({ 'aria-current': false, 'data-featured': false, 'aria-hidden': true })

            const currentRegion = document.querySelector('.location-region[aria-current="true"]')

            ShowChildLocations(currentRegion.getAttribute('data-id'))

            Array.from(allTownsList).forEach((town) => {
                let id = town.getAttribute('data-id').toString()
                if (featuredIds.includes(id)) {
                    new Helpers(town).setAttributes({ 'data-featured': true, 'aria-hidden': false })
                }
            })
            document.getElementsByClassName('map-link')[0].setAttribute('href', destinationUrl(true))
            document.getElementsByClassName('super-search__select-location')[0].setAttribute('aria-expanded', false)

            locationModified = true
            runSearch()
        })

        let ShowChildLocations = (currentID) => {
            if (currentID !== '' && currentID !== null && typeof currentID !== 'undefined') {
                var childItems = document.querySelectorAll('.location[data-parent-id="' + currentID + '"]')
                Array.from(childItems).forEach((ci) => {
                    if (new Helpers(ci).hasClass('location-town')) {
                        ci.setAttribute('aria-hidden', false)
                    }
                    ShowChildLocations(ci.getAttribute('data-id'))
                })

            }
        }

        new Helpers(allTowns).eventListener((e) => {
            e.preventDefault()
            const li = new Helpers(e.target).getClosest('li')
            if (li !== undefined) {
                new Helpers(allTowns.getElementsByClassName('location-town')).setAttributes({ 'aria-current': false })
                new Helpers(li).setAttributes({ 'aria-current': true })
                distance.value = li.getAttribute('data-distance')
                distance.dispatchEvent(new CustomEvent('sync'))

                locationModified = true
                runSearch()
            }
        })

        let whereSearch = document.getElementsByClassName('super-search__where-search')[0]
        let whereResults = document.getElementsByClassName('super-search__where-results')[0]
        let geoSearch = new GeoSearch(whereSearch, whereResults, {
            placeholderText: {
                focus: 'Enter place or cottage name...',
                blur: 'Where would you like to go'
            }
        })
        new Helpers(document.getElementsByClassName('super-search__towns-toggle')).eventListener((e) => {
            e.preventDefault()
            e.stopPropagation()
            new Helpers(document.getElementsByClassName('super-search__select-location')).toggleAttribute('aria-expanded')
        })

        new Helpers(whereSearch).eventListener((e) => {
            e.stopPropagation()
            e.preventDefault()
        }, 'keyup')

        geoSearch.on('select', (data) => {
            switch (data.type) {
                case 'Region':
                    Array.from(regions).find(region => region.getAttribute('data-value') == data.code).click()
                    break
                case 'Location':
                    Array.from(allTowns.getElementsByClassName('location-town')).find(town => town.getAttribute('data-code') == data.code).click()
                    break
                case 'Cottage':
                    window.location = data.url
                    break
                default:
                // no action
            }
            geoSearch.clearResults()
        })

        geoSearch.on('invalid', (value) => {
            if (value.length === 0) {
                // set back to UK country
                Array.from(regions).filter(r => r.getAttribute('data-value') === rootLocationRegionCode)[0].click()
            } else {
                // partial value present, reset the buttons
                updateButtons(getParams())
            }
        })

        const guestControls = document.getElementsByClassName('super-search__select-guests-control')
        const calendarContainer = document.getElementsByClassName('calendar-range')[0]
        const durationInput = document.getElementsByName('duration')[0]
        const startDateInput = document.getElementsByName('startDate')[0]
        const endDateInput = document.getElementsByName('endDate')[0]
        const flexWrap = document.getElementsByClassName('super-search__flex')[0]
        const flexInput = document.getElementsByName('flex')[0]
        const clearDatesButton = document.getElementsByClassName('super-search__dates-clear')[0]
        
        // initialise the guest picker controls
        Array.from(guestControls).forEach(control => new ButtonCounter(control))
        new Helpers(guestControls).eventListener(() => {
            runSearch()
        }, 'change')

        let calcNoOfCalendars = () => {
            return window.outerWidth <= 1050 ? 1 : 2
        }

        let noOfCalendars = calcNoOfCalendars()

        window.addEventListener('resize', () => {
            if (noOfCalendars !== calcNoOfCalendars()) {
                noOfCalendars = calcNoOfCalendars()
                calendar.setNoOfCalendars(noOfCalendars).render()
            }
        })

        // initialise the calendar
        let calendar = new CalendarRange(calendarContainer, (startDate, endDate) => {
            startDateInput.value = ''
            endDateInput.value = ''
            if (startDate !== null) {
                startDateInput.value = startDate.format('ddd D MMM YYYY')

                let duration = parseInt(durationInput.value, 10)

                if (endDate !== null) {
                    endDateInput.value = endDate.format('ddd D MMM YYYY')

                    if (duration === 0 || endDate.diff(startDate, 'days') < duration) {
                        // duration hasn't been set or is no longer valid for date range,
                        // infer it from the dates
                        duration = Math.min(Math.max(endDate.diff(startDate, 'days'), 2), 7)
                        durationInput.value = duration
                    }

                    if (endDate.diff(startDate, 'days') < duration) {
                        calendar.setDates(startDate, moment(startDate).add(duration, 'days'))
                    }
                }

                flexWrap.setAttribute('aria-hidden', false)
                clearDatesButton.setAttribute('aria-hidden', false)
            }

            runSearch()
        })
        calendar.setNoOfCalendars(calcNoOfCalendars()).render()

        // duration
        new Helpers(durationInput).eventListener(() => {
            const startDate = moment(startDateInput.value, 'ddd D MMM YYYY')
            const endDate = moment(endDateInput.value, 'ddd D MMM YYYY')
            const duration = parseInt(durationInput.value, 10)

            if (!startDate.isValid() || !endDate.isValid()) {
                // dates not set, no need to execute validation here
                runSearch()
                return
            } else if (duration === 0) {
                // dates are set and no duration provided, do so...
                const impliedDuration = Math.max(endDate.diff(startDate, 'days'), 2)
                durationInput.value = impliedDuration
            }

            if (endDate.diff(startDate, 'days') < duration) {
                calendar.setDates(startDate, moment(startDate).add(duration, 'days'))
            }
            runSearch()
        }, 'change')

        new Helpers(flexInput).eventListener(() => {
            runSearch()
        })
        // reset dates input button click
        new Helpers(clearDatesButton).eventListener((e) => {
            e.preventDefault()
            durationInput.value = 0
            startDateInput.value = ''
            endDateInput.value = ''
            calendar.setDates(null, null)
            clearDatesButton.setAttribute('aria-hidden', true)
            flexWrap.setAttribute('aria-hidden', true)
            runSearch()
        })

        let getParams = () => {
            const params = {}
            const region = superSearch.querySelector('.super-search__areas li[aria-current="true"]')
            const town = superSearch.querySelector('.super-search__locations li[aria-current="true"]')
            const distance = parseInt(document.getElementsByName('distance')[0].value, 10)
            const duration = parseInt(document.getElementsByName('duration')[0].value, 10)
            const startDate = document.getElementsByName('startDate')[0].value
            const endDate = document.getElementsByName('endDate')[0].value
            const flex = parseInt(document.getElementsByName('flex')[0].value, 10)
            const adults = parseInt(document.getElementsByName('adults')[0].value, 10)
            const children = parseInt(document.getElementsByName('children')[0].value, 10)
            const babies = parseInt(document.getElementsByName('babies')[0].value, 10)
            const pets = parseInt(document.getElementsByName('pets')[0].value, 10)

            if (town !== null) {
                params.nlc = town.getAttribute('data-url-name')
                params.nlm = distance
            } else if (region.getAttribute('data-value') !== rootLocationRegionCode) {
                params.rgn = region.getAttribute('data-value')
            }
            if (duration > 0) {
                params.nday = duration
            }
            if (startDate !== '') {
                params.dss = startDate
                if (endDate !== '') {
                    params.des = endDate
                } else if (duration > 0) {
                    params.des = moment(startDate, 'ddd D MMM YYYY').add(duration, 'days').format('ddd D MMM YYYY')
                }
                if (flex !== 3) {
                    params.flex = flex
                }
            }
            if (duration > 0 && startDate !== '' && endDate !== '') {
                // Store search dates for use on cottage availability form.
                try {
                    const dates = {
                        dss: moment(startDate, 'ddd D MMM YYYY').toISOString(true),
                        des: moment(endDate, 'ddd D MMM YYYY').toISOString(true),
                        nday: duration,
                    }
                    sessionStorage.setItem('searchDates', JSON.stringify(dates))
                } catch (e) {
                    console.log(e)
                }
            }

            if (adults > 1) params.minA = adults
            if (children > 0) params.minC = children
            if (babies > 0) params.minB = babies
            if (pets > 0) params.pet = pets

            return params
        }

        let updateButtons = (params) => {
            const guests = (params.minA || 1) + (params.minC || 0) + (params.minB || 0)
            const pets = params.pet || 0

            // Where
            let whereTitle = ''
            if (params.nlc !== undefined) {
                whereTitle = allTowns.querySelector(`li[data-url-name="${params.nlc}"]`).getAttribute('data-title')
            } else if (params.rgn !== undefined) {
                whereTitle = Array.from(regions).filter(r => r.getAttribute('data-value') === params.rgn)[0].getAttribute('data-title')
            }
            geoSearch.setValue(whereTitle)

            // When
            const howLongTitle = params.nday > 0 ? document.getElementsByName('duration')[0].querySelector('option:checked').innerText : ''
            const howLongSub = params.nday > 0 && params.des !== undefined ? moment(params.dss, 'ddd D MMM YYYY').format('DD/MM/YYYY') + ' - ' + moment(params.des, 'ddd D MMM YYYY').format('DD/MM/YYYY') : ''
            setButton('howLongToggle', params.nday > 0, howLongTitle, howLongSub)

            // Guests
            const guestsTitle = `${guests} Guest${guests !== 1 ? 's' : ''}`
            const guestsSub = `${pets} Dog${pets !== 1 ? 's' : ''}`
            setButton('noOfGuestsToggle', guests > 1 || pets > 0, guestsTitle, guestsSub)
        }


        let setButton = (id, set, title, sub) => {
            const buttonSetClass = 'super-search__button--set'
            const titleClass = 'super-search__button-text-title'
            const subClass = 'super-search__button-text-sub'
            const button = document.getElementById(id)
            if (set) {
                new Helpers(button).addClass(buttonSetClass)
                button.getElementsByClassName(titleClass)[0].innerText = title
                button.getElementsByClassName(subClass)[0].innerText = sub
            } else {
                new Helpers(button).removeClass(buttonSetClass)
                button.getElementsByClassName(titleClass)[0].innerText = ''
                button.getElementsByClassName(subClass)[0].innerText = ''
            }
        }

        let queryString = params => Object.keys(params)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&')

        let getGeography = () => {
            const region = superSearch.querySelector('.super-search__areas li[aria-current="true"]')
            const town = superSearch.querySelector('.super-search__locations li[aria-current="true"]')

            let locationId = 0
            let locationDistance = -1

            if (town !== null) {
                locationId = town.getAttribute('data-id')
                locationDistance = parseInt(document.getElementsByName('distance')[0].value, 10)
            } else if (region !== null) {
                locationId = region.getAttribute('data-id')
            }

            if (activeGeoFetch !== -1) {
                activeGeoFetch.getXHR().abort()
            }

            activeGeoFetch = new XHRPromise()
            activeGeoFetch.send({
                url: `/feeds/geography.aspx?locationId=${locationId}&distance=${locationDistance}`,
            })
                .then(response => (new window.DOMParser()).parseFromString(response.responseText, 'text/xml'))
                .then((data) => {
                    const location = data.getElementsByTagName('location')
                    if (location.length > 0) {
                        updateMap(location[0].getAttribute('wkt'))
                    }
                    activeGeoFetch = -1
                }).catch((error) => {
                    if (error.reason !== 'abort') {
                        console.log(error)
                    }
                })
        }

        let runSearch = () => {
            Array.from(superSearch.querySelectorAll('button[name="submit"]')).forEach(b => b.innerHTML === '...')
            const params = getParams()
            updateButtons(params)

            if (locationModified) {
                getGeography()
            }

            const feedEndpoint = `/feeds/resultsFeed.aspx?search=Y&${queryString(params)}`

            if (activeFetch !== -1) {
                activeFetch.getXHR().abort()
            }

            activeFetch = new XHRPromise()
            activeFetch.send({
                url: feedEndpoint,
            })
                .then(response => (new window.DOMParser()).parseFromString(response.responseText, 'text/xml'))
                .then((data) => {
                    updateUI(data)
                    activeFetch = -1
                }).catch((error) => {
                    if (error.reason !== 'abort') {
                        console.log(error)
                    }
                })
        }

        let updateUI = (data) => {
            const total = parseInt(data.getElementsByTagName('total')[0].getAttribute('total'), 10)

            // set total
            Array.from(superSearch.querySelectorAll('button[name="submit"]')).forEach(b => b.innerHTML = `<strong>Search</strong> <span>${total}</span> cottage${total !== 1 ? 's' : ''}`)

            // set regions
            Array.from(regions).forEach((region) => {
                const code = region.getAttribute('data-value')
                const regionTotal = data.getElementsByTagName('regionTotals')[0].getAttribute(code.toLowerCase())
                region.getElementsByTagName('span')[0].innerText = regionTotal
            })
        }


        let map = null

        let initMap = () => {
            if (map === null) {
                map = new Map('superSearchMap', {
                    coords: [50.1016, -5.2750],
                    zoom: 9,
                    minZoom: 4,
                    maxZoom: 14,
                    zoomControl: false,
                    attributionControl: false,
                    dragging: false,
                    doubleClickZoom: false,
                    scrollWheelZoom: false,
                }, {
                    LocationMap: streetLayer(),
                })
            }
        }
        let updateMap = (wkt) => {
            initMap()
            map.map.invalidateSize()
            map
                .clearShapes()
                .addShape(wkt, { color: '#29abe3' })
                .fitShapes()
        }
    })()
}
